import { debounce } from 'lodash';

import { getSearchTerms } from 'application/util/search.util';

import './search.style.sass';
import template from './search.tpl.pug';

class SearchController {
    /* @ngInject */
    constructor($scope) {
        this.search = debounce((term) => $scope.$applyAsync(this.changed.bind(this, term)), 250);
    }

    changed(term) {
        return this.onTermChange({
            terms: getSearchTerms(term)
        });
    }

    submit(term) {
        return this.onSubmit({
            terms: getSearchTerms(term)
        });
    }

    open() {
        return this.onFocusChange({
            focused: true
        });
    }

    close() {
        return this.onFocusChange({
            focused: false
        });
    }

    clear() {
        this.term = null;
        this.changed();
    }

    handleClear(code) {
        switch (code) {
            case 27:
                this.clear();
                this.close();
                return false;
        }

        return true;
    }
}

export default {
    selector: 'dbASearch',
    template: template(),
    controller: SearchController,
    bindings: {
        id: '@',
        placeholder: '<',
        term: '<',

        canCapture: '<',

        onFocusChange: '&',
        onTermChange: '&',
        onSubmit: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/search/search.cmpt.js